import React from 'react'
import { Space, Text } from 'components'
import { css } from 'emotion'
import { MEDIA_QUERY } from 'styles'

const SummaryContainerView = ({
  isCartEmpty,
  waitTime,
  SummaryElement,
  DeliveryElement,
  NotesInputElement,
  SubmitButtonElement,
}) => {
  if (isCartEmpty) {
    return (
      <div className={styles.cart}>
        <Text content h1 black center className={styles.emptyText}>
          Cart is empty. <br />
          Add items from the Menu.
        </Text>
      </div>
    )
  }
  return (
    <div className={styles.cart}>
      {DeliveryElement}
      <Space h2 />
      {SummaryElement}
      <Space h2 />
      {NotesInputElement}
      <Space h1 />
      <Text content h4 black>
        * Additional charges may apply for Special Requests
      </Text>
      <Space h3 />
      <div className={styles.button}>{SubmitButtonElement}</div>
    </div>
  )
}

const styles = {
  cart: css({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  }),
  button: css({
    alignSelf: 'center',
  }),
  emptyText: css({
    position: 'relative',
    [MEDIA_QUERY.LG]: {
      bottom: 0,
    },
  }),
}

export default SummaryContainerView
